import { getPath } from "../../utils";

const initialState = {
  tripStatisticsData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_TRIP_STATISTICS_DATA":
      return setTripStatisticsData(state, action);
    case "RESET_STATE_TRIP_STATISTICS":
      return resetState(state, action);
    default:
      return state;
  }
}

const setTripStatisticsData = (state, action) => {
  return {
    ...state,
    tripStatisticsData: getPath(action.payload, "trip_statistics_data", []),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: [],
  };
};
